(ns kyber.components.base.badge
  (:require [kyber.components.base.text :as text]
            [kyber.styles.core :refer [styles->classes gs]]))

(def base-styles
  {:border-radius (gs [:radius :r40])
   :padding [(gs [:spacing :p1])
             (gs [:spacing :p12])
             (gs [:spacing :p2])]})

(def classes
  (styles->classes
   {:neutral
    (merge base-styles
           {:color (gs [:colors :gray-scale-600])
            :background-color (gs [:colors :gray-scale-300])})
    :success
    (merge base-styles
           {:color (gs [:colors :green-800])
            :background-color (gs [:colors :green-300])})}))


(defn render
  [{:keys [label variant]
    :or {variant :neutral}}]
  [:div {:class [(:base classes)
                 (get classes variant)]}
   [text/caption-10 :span {:style {:color :inherit
                                   :font-weight (gs [:font-weight :title-10])}}
    label]])
